// 日本語テーブル（機械翻訳・未校正 — ruling G4）。
// The Japanese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
import { FITS, DEPTH, SNAP, snapOverlap, fmt } from '../doc.js';
const S = {
  title: "ロゴ入りコーヒーカップ",
  gLogo: "カップのロゴ",
  gSize: "カップサイズ",
  gColour: "カラー",
  gLid: "フタとプリント",
  loadingFont: (family, got, total) => (total > 0 ? `${family} を読み込み中 ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `${family} を読み込み中 ${got.toFixed(1)} MB`),
  needFile: "ロゴのSVGファイルを選んでください — 端末内に留まり、どこにも送信されません",
  artKept: "ロゴはこのタブ内にだけ存在します — 再読み込み後はファイルを再選択してください",
  keptOld: "（引き続き前のロゴを使用）",
  thumb: "読み込んだロゴのプレビュー",
  mode: "ロゴスタイル",
  modes: {
    flush: "フラッシュ",
    raised: "盛り上げ",
    engraved: "彫刻",
  },
  styleLabel: "カップ形状",
  styles: {
    classic: "クラシック形状",
    thin: "本当の薄壁",
  },
  modeNote: (style, mode) => {
      if (mode === 'raised') return `盛り上げ ${fmt(DEPTH[style].raised[1])} mm — マルチカラーと単色プリンターの両方でプリントできます（単色では浮き出しになります）`;
      if (mode === 'engraved') return `彫刻 ${fmt(DEPTH[style].engraved[0])} mm — ロゴは別パーツになりません — 単色プリンター向き`;
      const flush = 'カップ面とフラット — マルチカラープリンター向け（単色ではロゴが見えません）';
      return style === 'thin' ? `${flush} 薄壁: ロゴの厚さ ${fmt(DEPTH.thin.flush[0])} mm — 濃いカップの淡いロゴは暗くなりがち — くっきりした色には盛り上げを` : flush;
    },
  scale: "ロゴサイズ",
  pos: "上下に移動",
  hideThin: "薄すぎてプリントできない部分を隠す",
  signedPercent: (v) => `${v > 0 ? '+' : ''}${Math.round(v * 100)}%`,
  size: "サイズ",
  presets: {
    mini: "ミニ",
    s: "S",
    m: "M",
    l: "L",
  },
  d: "直径（mm）",
  adjusted: (v, lo, hi) => `${v} mm に設定しました（可能範囲 ${lo}–${hi} mm）`,
  looks: "カラーセット",
  lookNames: {
    mono: "白黒",
    kraft: "クラフト",
    white: "ホワイト",
  },
  parts: {
    body: "カップ",
    ring: "リング",
    logo: "ロゴ",
  },
  colour: {
    body: "カップの色",
    lid: "フタの色",
    ring: "リングの色",
    logo: "ロゴの色",
  },
  lidOn: "フタを追加",
  ringOn: "リング",
  fit: "フタのフィット",
  fits: {
    tight: "きつい",
    snug: "ジャスト",
    normal: "少しゆるめ",
    loose: "ゆるめ",
  },
  fitNote: (style, fit, d) => {
      if (style !== 'thin') return `${fmt(FITS[fit])} mm の隙間 — フタは摩擦で留まり、バチはありません`;
      if (fit === 'loose') return `フタはゆるく留まりません — 両側 ${fmt(SNAP.loose.c)} mm の隙間`;
      return `フタは縁の下で留まります — オーバーラップ ${snapOverlap(SNAP[fit], d).toFixed(2)} mm`;
    },
  partLabel: "ダウンロードしたファイル",
  partNames: {
    set: "設定",
    cup: "カップ",
    lid: "フタ",
  },
  lift: "フタを開ける",
  outer: (d, h) => `ø ${d} × ${h} mm`,
  footprint: (w, d) => `プリント面 ${w} × ${d} mm`,
  capacity: (ml) => `容量 ${ml} ml`,
  problem: {
    "thin-text": "文字がとても細い — プリントできない線があるかもしれません — より大きいカップか少ない文字数でお試しください",
    "thin-parts": "ロゴの太い部分に細い線が付いています — スライサーで切り捨てられる可能性があります",
    dropped: (p) => `薄すぎてプリントできない部分 ${p.n} 個をロゴから落としました`,
    "all-thin": "ロゴがこのカップサイズに対して薄すぎます — ダウンロードできません",
    "art-too-complex": "ロゴが複雑すぎます — ダウンロードできません",
  },
  hairline: "制限: ロゴの太い部分に付いた非常に細い線は検出できず、スライサーで切り捨てられる可能性があります — プリント前にスライサーのプレビューで確認してください",
  dlstl: "STL",
  copied: "コピーしました",
  fatal: "計算機を読み込めません — ページを再読み込みしてください",
  buildTimeout: (src) => (src === 'svg' ? '生成が10秒で終わらず再開しました — もっと単純なファイルをお試しください' : '生成が10秒で終わらず再開しました — 文字を減らすか別のフォントを'),
  aboutP: "フタ付きミニコーヒーカップをデザイン — 本体に名前やお店のロゴを入れ、サイズ・色・フタのフィットを選んで 3MF/STL を無料ダウンロード。飾り用モデルで、飲み物を入れる容器ではありません。",
};
export default S;
